import { Col, SegmentControl } from 'components';
import { useSearchParams } from 'react-router-dom';
import DomainsTab from './DomainsTab';
import KeywordsTab from './KeywordsTab';

const SUB_TABS = ['Spam Domains', 'Blocked Keywords'];
const SUB_TAB_KEYS = ['domains', 'keywords'];

/** Spam management: domain blocklist + hard-blocked business-rule keywords. */
const SpamTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const subIdx = Math.max(0, SUB_TAB_KEYS.indexOf(searchParams.get('sub')));
  const setSub = (idx) => setSearchParams({ tab: 'spam', sub: SUB_TAB_KEYS[idx] });

  return (
    <Col noFlex wid="100%">
      <SegmentControl
        options={SUB_TABS}
        selectedIdx={subIdx}
        handleSelect={setSub}
        small
        wid="360px"
        marg="0 0 16px"
        textStyle={{ size: '13px' }}
      />

      {subIdx === 0 && <DomainsTab />}
      {subIdx === 1 && <KeywordsTab />}
    </Col>
  );
};

export default SpamTab;
